import { bindActionCreators as actionCreators } from 'redux';

/**
 * returns a set of actions after binding dispatch
 * @param {Function} dispatch - redux dispatch function
 */
// eslint-disable-next-line import/prefer-default-export
export const bindActionCreators = (actions) => (dispatch) => ({
  actions: actionCreators(actions, dispatch),
});
